import { getTaxes } from "@/api/gql/tax";
import { ITax, TaxType } from "@/types/db/product-category";

/**
 * Fetches all product categories of a given list of ticket groups
 * from remote db and store them locally
 * @param ids Ticket Group ids
 */
export async function fetchTaxes(ids: number[]) {
  const taxes = await getTaxes(ids);
  return taxes;
}

/**
 * Calculates the total tax for one pss
 * @param priceValue: the pss price after discounts
 * @param pssTaxes: list of all pss taxes
 * @param taxType: 1: Excluded, 0: Included
 */
export function getTotalTax(
  priceValue: number,
  pssTaxes: ITax[],
  taxType: TaxType
): number {
  const includedInPrice = taxType === TaxType.ExcludedTax ? 0 : 1;
  let sum = 0;
  const taxes = pssTaxes.filter((t) => t.includedInPrice === includedInPrice);
  for (const tax of taxes) {
    sum += getTaxValue(priceValue, tax);
  }
  return sum;
}

/**
 * Calculates the tax value using the tax rate
 * @param priceValue
 * @param tax
 */
export function getTaxValue(priceValue: number, tax: ITax): number {
  const rate = Number(tax.rateMiliValue);
  let taxValue = 0;
  if (tax.includedInPrice === 1) {
    // included taxes formula
    taxValue = Math.round((priceValue * (rate / 100)) / (1 + rate / 1_000_000));
  } else {
    // excluded taxes formula
    taxValue = Math.round(priceValue * (rate / 100));
  }
  return parseInt(taxValue.toFixed(6));
}
